/**
 * @generated SignedSource<<d6fa3bbdeb9f2a2928673193a08a5eee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StatsPanelRecapQuery$variables = {
  id: string;
};
export type StatsPanelRecapQuery$data = {
  readonly node: {
    readonly __typename?: "MeetingRecording";
    readonly recapEngagementStats?: {
      readonly hasLegacyViews: boolean;
      readonly minutesSaved: number;
      readonly totalViewCount: number;
      readonly viewers: ReadonlyArray<{
        readonly displayName: string | null;
        readonly user: {
          readonly email: string;
          readonly fullName: string;
          readonly image: string;
        } | null;
        readonly viewCount: number;
        readonly watchPercentage: number;
      }>;
    } | null;
  } | {
    readonly __typename?: "MeetingRecordingClip";
    readonly recapEngagementStats?: {
      readonly hasLegacyViews: boolean;
      readonly minutesSaved: number;
      readonly totalViewCount: number;
      readonly viewers: ReadonlyArray<{
        readonly displayName: string | null;
        readonly user: {
          readonly email: string;
          readonly fullName: string;
          readonly image: string;
        } | null;
        readonly viewCount: number;
        readonly watchPercentage: number;
      }>;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type StatsPanelRecapQuery = {
  response: StatsPanelRecapQuery$data;
  variables: StatsPanelRecapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "watchPercentage",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalViewCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesSaved",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLegacyViews",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RecapEngagementStats",
    "kind": "LinkedField",
    "name": "recapEngagementStats",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecapEngagementViewer",
        "kind": "LinkedField",
        "name": "viewers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RecapEngagementStats",
    "kind": "LinkedField",
    "name": "recapEngagementStats",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecapEngagementViewer",
        "kind": "LinkedField",
        "name": "viewers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StatsPanelRecapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v12/*: any*/),
                "type": "MeetingRecording",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v12/*: any*/),
                "type": "MeetingRecordingClip",
                "abstractKey": null
              }
            ],
            "type": "MeetingRecordingInterface",
            "abstractKey": "__isMeetingRecordingInterface"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatsPanelRecapQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v13/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v14/*: any*/),
                "type": "MeetingRecording",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v14/*: any*/),
                "type": "MeetingRecordingClip",
                "abstractKey": null
              }
            ],
            "type": "MeetingRecordingInterface",
            "abstractKey": "__isMeetingRecordingInterface"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f115c0cddf11d763be38d72f34ab722",
    "id": null,
    "metadata": {},
    "name": "StatsPanelRecapQuery",
    "operationKind": "query",
    "text": "query StatsPanelRecapQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on MeetingRecordingInterface {\n      __isMeetingRecordingInterface: __typename\n      __typename\n      ... on MeetingRecording {\n        recapEngagementStats {\n          viewers {\n            user {\n              email\n              fullName\n              image\n              id\n            }\n            displayName\n            viewCount\n            watchPercentage\n          }\n          totalViewCount\n          minutesSaved\n          hasLegacyViews\n        }\n      }\n      ... on MeetingRecordingClip {\n        recapEngagementStats {\n          viewers {\n            user {\n              email\n              fullName\n              image\n              id\n            }\n            displayName\n            viewCount\n            watchPercentage\n          }\n          totalViewCount\n          minutesSaved\n          hasLegacyViews\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "650bacc69505d6e76fc14f65dff3340f";

export default node;
